import React from 'react';
import type { GuidePage } from '../data/activities';
type GuidePagePreviewProps = {
  page: GuidePage;
};
export function GuidePagePreview({
  page
}: GuidePagePreviewProps) {
  return <figure className="h-full overflow-hidden rounded-2xl border border-line bg-[#1a1a1d] shadow-[0_30px_60px_-30px_rgba(0,0,0,0.8)]" data-id="element-9" data-mp="1wk0vn6a14iz">
      <img src={page.image} alt={page.alt} className="block h-auto w-full" loading="lazy" data-id="element-10" data-mp="6nscmpv2x1zb" />
      <figcaption className="sr-only" data-id="element-11" data-mp="bl1zbxr32zjg">{page.title}</figcaption>
    </figure>;
}